// Web-only strings for the installed-app pieces: the "new version" banner, release notes in Settings,
// the share target picker, notification actions and the call's audio output. BOTH languages. The
// release-note texts themselves are the Apple keys (`releaseNotes.*`), the actions `mac.notification.*`.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.dlp.title': 'El programa de seguridad de tu computadora bloqueó Satori Chat',
    'web.dlp.body': 'Un filtro de datos (DLP) instalado en este equipo impidió enviar información — un mensaje o un archivo pudo no llegar. Pide a tu área de TI que permita %@.',
    'web.dlp.ok': 'Entendido',
    'web.update.available': 'Hay una versión nueva de Satori Chat',
    'web.update.availableVersion': 'Hay una versión nueva de Satori Chat (%@)',
    'web.update.reload': 'Actualizar',
    'web.update.hint': 'Se recargará la página; no perderás nada de lo que escribiste.',
    'web.releaseNotes.settingsRow': 'Novedades de la versión',
    'web.releaseNotes.settingsFooter': 'Lo que cambió en cada versión de Satori Chat.',
    'web.share.pickerHint': 'Elige la conversación. Podrás revisar el mensaje antes de enviarlo.',
    'web.share.staged': 'Listo para enviar en %@',
    'web.share.expired': 'Lo que compartiste ya no está disponible. Vuelve a compartirlo.',
    'web.share.empty': 'No llegó nada para compartir.',
    'web.notify.replyPlaceholder': 'Escribe un mensaje',
    'web.call.audioOutput': 'Salida de audio',
    'web.call.audioOutput.default': 'Predeterminada del sistema',
  },
  en: {
    'web.dlp.title': "Your computer's security software blocked Satori Chat",
    'web.dlp.body': 'A data filter (DLP) installed on this computer stopped information from being sent — a message or a file may not have arrived. Ask your IT team to allow %@.',
    'web.dlp.ok': 'Got it',
    'web.update.available': 'A new version of Satori Chat is available',
    'web.update.availableVersion': 'A new version of Satori Chat is available (%@)',
    'web.update.reload': 'Update',
    'web.update.hint': 'The page will reload; nothing you typed is lost.',
    'web.releaseNotes.settingsRow': 'Release notes',
    'web.releaseNotes.settingsFooter': 'What changed in each version of Satori Chat.',
    'web.share.pickerHint': 'Pick the conversation. You can review the message before sending it.',
    'web.share.staged': 'Ready to send in %@',
    'web.share.expired': 'What you shared is no longer available. Share it again.',
    'web.share.empty': 'Nothing arrived to share.',
    'web.notify.replyPlaceholder': 'Write a message',
    'web.call.audioOutput': 'Audio output',
    'web.call.audioOutput.default': 'System default',
  },
};
